module.exports = __webpack_public_path__ + "static/media/facebook.a79ea0a6.svg";